import type { IncentiveStoreDAO } from "@/domains/incentive"
import type { ITokenLookup } from "@/domains/tokens/types"
import { LcAddress } from "@/domains/core"

import type { GaugeStoreDAO } from "./interfaces"
import type { GaugeApiData } from "./types"

/**
 * Convert raw API response to Gauge Store DAO
 * Transforms the API response structure into a cleaner, domain-aligned shape:
 * - Converts incentives from Record to Array format
 */
export function convertApiResponseToGaugeStoreDAO(apiItem: GaugeApiData, tokenLookup: ITokenLookup): GaugeStoreDAO {
  const transformedIncentives: Array<IncentiveStoreDAO> = Object.entries(apiItem.incentives)
    .map(([tokenAddress, incentiveData]) => {
      const token = tokenLookup.find(new LcAddress(tokenAddress))
      if (!token) {
        console.warn(`Token not found for incentive address: ${tokenAddress}`)
        return null
      }

      return {
        reward: token,
        rewardAmount: incentiveData.rewardAmount,
      }
    })
    .filter((incentive): incentive is IncentiveStoreDAO => incentive !== null)

  return {
    address: new LcAddress(apiItem.address),
    revenueSourceAddress: new LcAddress(apiItem.pair.address),
    bribeAddress: new LcAddress(apiItem.bribeAddress),
    apr: apiItem.apr,
    aprLastEpoch: apiItem.aprLastEpoch,
    rewardRate: apiItem.rewardRate,
    totalBribeValueUsd: apiItem.totalBribeValueUsd,
    totalSupply: apiItem.totalSupply,
    votes: apiItem.votes,
    votesPercent: apiItem.votesPercent,
    incentives: transformedIncentives,
  }
}
